import { render, staticRenderFns } from "./tougao.vue?vue&type=template&id=70480726&"
import script from "./tougao.vue?vue&type=script&lang=js&"
export * from "./tougao.vue?vue&type=script&lang=js&"
import style0 from "./tougao.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports